export default __webpack_public_path__ + "static/7-91a98a3e58ebbea8405f4bc07f9b8dfe.jpg";